export const YOUTUBE_VIDEOS_API =
  "https://corsproxy.io/?https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=CA&key=AIzaSyCiKah3JsAS7KXgRQU7aokmQQisJeD1giY";

export const API_KEY = "AIzaSyCiKah3JsAS7KXgRQU7aokmQQisJeD1giY";

export const YOUTUBE_SERACH_API =
  "https://corsproxy.io/?http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

export const YOUTUBE_SERACH_RESULTS =
  "https://corsproxy.io/?https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&q=";

export const YOUTUBE_COMMENTS_THREAD =
  "https://corsproxy.io/?https://youtube.googleapis.com/youtube/v3/commentThreads?part=snippet%2Creplies&videoId=";

  export const YOUTUBE_VIDEO_DETAILS =
  "https://corsproxy.io/?https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=";
